import React from 'react'

function TenderTextSemiTrap() {
  return (
    <embed src="\pdfs\EAT1.5.3.2_VA-TH_Semi-trapezoidal_displacement_outlet_01.2018_kr.pdf" width="100%" height="2100px" />
  )
}

export default TenderTextSemiTrap